import { createContext } from "react";

export const idContext = createContext();